import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-29ed7a29")

_pushScopeId("data-v-29ed7a29")
const _hoisted_1 = {
  key: 0,
  class: "message"
}
const _hoisted_2 = { class: "search-form part1" }
const _hoisted_3 = { class: "search-form part2" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "詳細検索", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down" }, null, -1)
const _hoisted_6 = { class: "detail-search-form" }
const _hoisted_7 = { class: "search-form part3" }
const _hoisted_8 = { class: "search-form part4" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("検索")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 新規申請")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Excel出力")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("クリア")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_date_picker = _resolveComponent("cus-date-picker")
  const _component_el_option = _resolveComponent("el-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_cus_input = _resolveComponent("cus-input")
  const _component_el_collapse_transition = _resolveComponent("el-collapse-transition")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_cus_table = _resolveComponent("cus-table")
  const _directive_access = _resolveDirective("access")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      (_ctx.isShinseisha)
        ? (_openBlock(), _createBlock("div", _hoisted_1, " ※委託開始日の１週間前までにアルトマークへ申請頂きますようお願いいたします。 "))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_cus_date_picker, {
          type: "daterange",
          "unlink-panels": "",
          "range-separator": "~",
          modelValue: _ctx.table.queryForm.startDate,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.table.queryForm.startDate = $event)),
          inputId: "searchStartDate",
          labelName: "開始日"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_cus_select, {
          modelValue: _ctx.table.queryForm.statusCd,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.table.queryForm.statusCd = $event)),
          size: "small",
          clearable: "",
          inputId: "searchStatus",
          labelName: "ステータス"
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusOptions, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.status,
                value: item.status_cd
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _withDirectives(_createVNode(_component_cus_select, {
          modelValue: _ctx.table.queryForm.kigyouShinchokuShinseiCd,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.table.queryForm.kigyouShinchokuShinseiCd = $event)),
          size: "small",
          clearable: "",
          inputId: "searchShinchokuShinsei",
          labelName: "企業内進捗",
          "popper-class": "shinchoku-shinsei"
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.shinchokuShinseiOptions, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.kigyonai_shinchoku,
                value: item.kigyonai_shinchoku_cd
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]), [
          [_directive_access, _ctx.ELEMENT_ACCESS.shinseiShinchokuShinseiInput]
        ]),
        _withDirectives(_createVNode(_component_cus_select, {
          modelValue: _ctx.table.queryForm.kigyouShinchokuShoninCd,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.table.queryForm.kigyouShinchokuShoninCd = $event)),
          size: "small",
          clearable: "",
          inputId: "searchShinchokuShonin",
          labelName: "企業内進捗",
          "popper-class": "shinchoku-shonin"
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.shinchokuShoninOptions, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.kigyonai_shinchoku,
                value: item.kigyonai_shinchoku_cd
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]), [
          [_directive_access, _ctx.ELEMENT_ACCESS.shinseiShinchokuShoninInput]
        ])
      ]),
      _createVNode("div", _hoisted_3, [
        _withDirectives(_createVNode(_component_cus_input, {
          inputId: "searchKaishaNm",
          labelName: "会社名",
          modelValue: _ctx.table.queryForm.kaishaNm,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.table.queryForm.kaishaNm = $event)),
          onEnterKeyUp: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleSearch(1)))
        }, null, 8, ["modelValue"]), [
          [_directive_access, _ctx.ELEMENT_ACCESS.shinseiKaishaNmInput]
        ]),
        _createVNode(_component_cus_input, {
          inputId: "searchGroupNm",
          labelName: "グループ名",
          modelValue: _ctx.table.queryForm.groupNm,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.table.queryForm.groupNm = $event)),
          onEnterKeyUp: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleSearch(1)))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_cus_input, {
          inputId: "searchTorukuName",
          labelName: "登録者名",
          modelValue: _ctx.table.queryForm.kjnNm,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.table.queryForm.kjnNm = $event)),
          onEnterKeyUp: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleSearch(1)))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_cus_input, {
          inputId: "searchBushoName",
          labelName: "部署名",
          modelValue: _ctx.table.queryForm.bushoNm,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.table.queryForm.bushoNm = $event)),
          onEnterKeyUp: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleSearch(1)))
        }, null, 8, ["modelValue"]),
        _createVNode("div", {
          class: ["detail-label", { open: _ctx.showDetailSearch }],
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showDetailSearch = !_ctx.showDetailSearch))
        }, [
          _hoisted_4,
          _hoisted_5
        ], 2)
      ]),
      _createVNode(_component_el_collapse_transition, null, {
        default: _withId(() => [
          _withDirectives(_createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_cus_input, {
                inputId: "searchItakuKaisha",
                labelName: "委託先会社名",
                modelValue: _ctx.table.queryForm.itakuKaishaNm,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.table.queryForm.itakuKaishaNm = $event)),
                onEnterKeyUp: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleSearch(1)))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_cus_input, {
                inputId: "searchSaiItakuKaisha",
                labelName: "再委託先会社名",
                modelValue: _ctx.table.queryForm.saiItakuKaishaNm,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.table.queryForm.saiItakuKaishaNm = $event)),
                onEnterKeyUp: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleSearch(1)))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_cus_input, {
                inputId: "searchMokuteki",
                labelName: "利用目的",
                modelValue: _ctx.table.queryForm.riyoMokuteki,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.table.queryForm.riyoMokuteki = $event)),
                onEnterKeyUp: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleSearch(1)))
              }, null, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_cus_date_picker, {
                type: "daterange",
                "unlink-panels": "",
                "range-separator": "~",
                modelValue: _ctx.table.queryForm.endDate,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.table.queryForm.endDate = $event)),
                inputId: "searchEndDate",
                labelName: "終了日"
              }, null, 8, ["modelValue"])
            ])
          ], 512), [
            [_vShow, _ctx.showDetailSearch]
          ])
        ]),
        _: 1
      }),
      _createVNode("div", null, [
        _createVNode(_component_el_button, {
          class: "search-button",
          type: "primary",
          icon: "el-icon-search",
          size: "mini",
          plain: "",
          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleSearch(1)))
        }, {
          default: _withId(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_el_button, {
          class: "add-button",
          type: "primary",
          icon: "el-icon-plus",
          size: "mini",
          plain: "",
          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.goToDetail()))
        }, {
          default: _withId(() => [
            _hoisted_10
          ]),
          _: 1
        }, 512), [
          [_directive_access, _ctx.ELEMENT_ACCESS.shinseiAddShinseiBtn]
        ]),
        _withDirectives(_createVNode(_component_el_button, {
          class: "excel-button",
          type: "primary",
          icon: "el-icon-download",
          size: "mini",
          plain: "",
          loading: _ctx.exportLoading,
          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleExport2excel()))
        }, {
          default: _withId(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["loading"]), [
          [_directive_access, _ctx.ELEMENT_ACCESS.shinseiExcelBtn]
        ]),
        _createVNode(_component_el_button, {
          class: "clear-button",
          icon: "el-icon-close",
          size: "mini",
          plain: "",
          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.handleClear()))
        }, {
          default: _withId(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_cus_table, {
      table: _ctx.table,
      currentPage: _ctx.table.queryForm.page,
      "onUpdate:currentPage": _cache[25] || (_cache[25] = ($event: any) => (_ctx.table.queryForm.page = $event)),
      "page-size": _ctx.table.queryForm.limit,
      "page-sizes": [20, 50, 80, 100],
      onCurrentChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.getList())),
      onSizeChange: _ctx.handleSizeChange,
      stripe: false,
      "row-class-name": _ctx.tableRowClassName,
      ref: "tableRef"
    }, {
      prepend: _withId(() => [
        _createVNode(_component_el_table_column, { type: "expand" }, {
          default: _withId((props) => [
            _createVNode(_component_el_form, {
              "label-position": "left",
              inline: "",
              class: "table-expand"
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableExpand, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_form_item, {
                    key: index,
                    label: item.label
                  }, {
                    default: _withId(() => [
                      _createVNode("span", null, _toDisplayString(props.row[item.prop]), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      columns: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableHeaderConfig, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            key: index,
            prop: item.prop,
            label: item.label,
            width: item.width ? item.width : '',
            "class-name": item.class,
            sortable: ""
          }, _createSlots({ _: 2 }, [
            (item.prop === 'statusNm')
              ? {
                  name: "default",
                  fn: _withId((scope) => [
                    _createVNode(_component_el_tag, {
                      size: "mini",
                      type: _ctx.statusFilter(scope.row[item.prop])
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(scope.row[item.prop]), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ])
                }
              : undefined
          ]), 1032, ["prop", "label", "width", "class-name"]))
        }), 128))
      ]),
      append: _withId(() => [
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "80"
        }, {
          default: _withId((scope) => [
            _createVNode("div", null, [
              _createVNode(_component_el_tooltip, {
                content: "詳細",
                placement: "left",
                effect: "light"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_button, {
                    class: "edit-btn",
                    circle: "",
                    size: "mini",
                    onClick: ($event: any) => (_ctx.goToDetail(scope.row.id)),
                    icon: "el-icon-edit",
                    plain: ""
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["table", "currentPage", "page-size", "onSizeChange", "row-class-name"])
  ], 64))
})